import { type FC } from "react";

export interface UnauthorizedMessageProps {
    text?: string;
    organizationId: string;
}

export const UnauthorizedMessage: FC<UnauthorizedMessageProps> = ({ text, organizationId }) => {
    return (
        <>
            {text}{" "}
            <a href={`https://business.snapchat.com/${organizationId}/settings/members`} target="_blank">
                Search & view role.
            </a>
        </>
    );
};
